import React, { useState } from 'react'
import { forgotPassword } from '../apiCallsHelper/authapicalls';
import { Link } from 'react-router-dom';
import todoLogo from "../images/TodoMate-logo.png"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from '../utils/LoadingOverlay';



const ForgotPassword = () => {

    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);



    const handleSubmit = () => {
        setIsLoading(true);
        forgotPassword(email).then(data => {
            if (data.error) {
                setIsLoading(false);
                toast.error(data.error);
            }
            else {
                setIsLoading(false);
                toast.success(data.message);
                setMessage(data.message);
                setEmail("");
            }
        })
    }


    


    return (
        <>
            <div className='forgot-password-container'>
                <Link className='mt-4 flex justify-center' to="/">
                    <img src={todoLogo} className='w-[80px] h-[80px]' alt="todo logo" />
                </Link>
                {isLoading && <LoadingOverlay />}
                <div className='w-[270px] h-[490px]   xs:w-[340px] xs:h-[460px]  sm:w-[470px] sm:h-[450px]  xl:w-[470px] xl:h-[450px]  container mt-[-40px] mx-auto border-2 border-gray-300 rounded-md'>
                    <div className='w-[250px]  xs:w-[310px] sm:w-[400px] xl:w-[400px]  mx-auto mt-4 '>
                        <div className='text-blue-500  mt-10 h-4 text-center'>
                            {message ? message : ""}
                        </div>
                        <div className='text-3xl mt-2 text-center font-bold text-[#183e70]'>
                            Forgot Password? No worries!
                        </div>
                        <div className='mt-6 text-[#183e70] '>
                            Enter the email address associated with your account.
                            A link will be sent to your inbox to recover password if an account exists for the email provided.
                        </div>
                        <div className='mt-4'>
                            <label htmlFor="recoveryEmail" className='font-semibold text-[#183e70]'>Email</label>
                            <input value={email} onChange={(event) => setEmail(event.target.value)} type="email" id="recoveryEmail" className="bg-gray-50 text-black  pl-2 pr-2 py-2 border border-gray-300  shadow-lg  shadow-blue-100 focus:outline-[#a6bffc] rounded w-full" />
                        </div>
                        <button onClick={handleSubmit} className='bg-[#8ab5ff] mt-10 py-2 w-full rounded-md hover:bg-[#7fa3e3] text-white'>Send email</button>
                        <Link className='mt-4 text-xs text-blue-500 cursor-pointer float-right' to="/signin">
                            Go back to login?
                        </Link>
                    </div>
                </div>

            </div>
        </>
    )
}




export default ForgotPassword